export default __webpack_public_path__ + "static/production-image-2-284ae6607d9bb49f253a18fc0ef21738.png";